/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reference: NonNullable<unknown> }} Following_To_StatusInputs */

const en_following_to_status = /** @type {(inputs: Following_To_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Follow status of ${i?.reference}`)
};

/**
* | output |
* | --- |
* | "Follow status of {reference}" |
*
* @param {Following_To_StatusInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const following_to_status = /** @type {((inputs: Following_To_StatusInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Following_To_StatusInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_following_to_status(inputs)
});